module.exports = __webpack_public_path__ + "img/dialog-word.aa1ccad3.png";